export default __webpack_public_path__ + "static/media/cena.ab89c385.png";